
class HeadingContent {
  constructor(bandId) {
      
  }
}

function initializeBlock(blockId) {
  new HeadingContent(`#${blockId}`);
}
if( window.acf ) {
  window.acf.addAction( 'render_block_preview/type=headingcontent', ( block ) => {
    if( block.length > 0 && 
      block[0].firstChild.id != '' && 
      block[0].firstChild.id != '#' )
      initializeBlock(block[0].firstChild.id);
  } );
}
else {
  let docBlocks = document.querySelectorAll('.tone__heading-content');
  for( let i = 0; i < docBlocks.length; i++ ){     
      initializeBlock(docBlocks[i].id);
  }
}